import { TiptapEditor } from "@circle-react-shared/uikit/TipTap";
import type { Profile } from "@circle-react/types/CommunityBot/Profile";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import { AgentAvatar } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/BotChatList/AgentAvatar";

import { AvatarSuggestedQuestions } from "./AvatarSuggestedQuestions";

interface AvatarConversationEmptyStateProps {
  agentName: string;
  agentProfile: Profile | null | undefined;
  avatarEditor?: ReactNode;
  bioEditor?: ReactNode;
  composer: ReactNode;
  nameEditor?: ReactNode;
  onSelectQuestion?: (question: string) => void;
  suggestionsEditor?: ReactNode;
}

export const AvatarConversationEmptyState = ({
  agentName,
  agentProfile,
  avatarEditor,
  bioEditor,
  composer,
  nameEditor,
  onSelectQuestion,
  suggestionsEditor,
}: AvatarConversationEmptyStateProps) => {
  const suggestedQuestions = agentProfile?.suggested_questions ?? [];
  const hasSuggestedQuestions =
    !!onSelectQuestion && suggestedQuestions.length > 0;
  const shouldShowReadOnlyBio = !bioEditor && !!agentProfile?.bio;
  const shouldShowDefaultAvatar = !avatarEditor && !!agentProfile;

  return (
    <div className="flex size-full min-h-0 flex-col">
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-6 overflow-y-auto px-4">
        {avatarEditor}
        {shouldShowDefaultAvatar && (
          <AgentAvatar profile={agentProfile} className="!h-16 !w-16" />
        )}
        <div className="flex w-full max-w-[420px] flex-col items-center gap-2 px-4 text-center">
          <div className="flex w-full justify-center">
            {nameEditor ?? (
              <Typography variant="heading-xl" component="h1">
                {agentName}
              </Typography>
            )}
          </div>
          {bioEditor}
          {shouldShowReadOnlyBio && (
            <div className="text-primary text-body-sm">
              <TiptapEditor
                editable={false}
                rich_text_body={agentProfile.bio}
              />
            </div>
          )}
        </div>
        {suggestionsEditor && (
          <div className="flex w-full max-w-2xl flex-col gap-10 pt-4">
            {composer}
            {suggestionsEditor}
          </div>
        )}
      </div>
      {!suggestionsEditor && (
        <div className="mx-auto flex w-full max-w-2xl shrink-0 flex-col gap-4 px-4 pb-5 pt-2">
          {hasSuggestedQuestions && (
            <AvatarSuggestedQuestions
              questions={suggestedQuestions}
              onSelect={onSelectQuestion}
            />
          )}
          {composer}
        </div>
      )}
    </div>
  );
};
